import { useEffect, useState } from 'react';

const reducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/**
 * Keeps an element mounted for `exitMs` after `open` goes false, so its exit
 * animation can play. `closing` is true during that window: style it with
 * [data-closing] and make it `inert` so nothing in it is reachable while it fades.
 * With reduced motion there is no exit animation, so it unmounts at once.
 */
export function usePresence(open: boolean, exitMs: number) {
  const [mounted, setMounted] = useState(open);

  useEffect(() => {
    if (open) {
      setMounted(true);
      return;
    }
    if (reducedMotion()) {
      setMounted(false);
      return;
    }
    const t = setTimeout(() => setMounted(false), exitMs);
    return () => clearTimeout(t);
  }, [open, exitMs]);

  return { mounted: open || mounted, closing: !open && mounted };
}
